import service from '@/utils/server';
let model = '/fm/fmMenu/'
export const queryList = data => {
    return service({
        url: model+'pageInfo',
        method: 'post',
        data
    })
};

export const saveObject = data => {
    return service({
        url:  model+'add',
        method: 'post',
        data
    })
};
//
export const getDeleteMenu = data => {
  return service({
    url: model+'delete/'+data.menuId,
    method: 'post'
  })
};

export const getUpdateMenu = data => {
  return service({
    url: model+'update',
    method: 'post',
    data
  })
};

export const getMenuOpList = data =>{
  return service({
    url: model+'listMenuPageOp/'+data.menuId,
    method: 'post'
  })
};
export const getExportData = data => {
  return service({
    url: model+'exportData/' + data.id,
    method: 'post'
  })
};



// WEBPACK FOOTER //
// ./src/page/auth/menu/api/index.js